import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["selectedTab", "setTab", "path"];
import styled from 'styled-components';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import { orderedTabs } from 'pricing-pages-ui/constants/routing/Tabs';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTabs = styled(UIRouterTabs).withConfig({
  displayName: "SegmentedTabs__StyledTabs",
  componentId: "sc-1x5fgwp-0"
})(["width:100%;text-align:center;margin-bottom:1px;"]);
const SegmentedTabs = _ref => {
  let {
      selectedTab,
      setTab = () => {},
      path = ''
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const renderTitleText = tabId => rest.use && rest.use === 'enclosed' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `pricingPage.tabs.enclosed.${tabId}`
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricingPage.tabs.${tabId}`
  });
  const handleTabClick = toTab => {
    getUsageTracker().track('internalLinkClick', {
      name: 'segmented-tab',
      fromTab: selectedTab,
      toTab
    });
    setTab(toTab);
  };
  return /*#__PURE__*/_jsx(StyledTabs, Object.assign({}, rest, {
    children: orderedTabs.map(tabId => {
      return /*#__PURE__*/_jsx(UIRouterTab, {
        active: selectedTab === tabId,
        title: renderTitleText(tabId),
        to: createToObject(`${path}/${tabId}`),
        onClick: () => handleTabClick(tabId),
        style: {
          fontSize: '16px'
        }
      }, tabId);
    })
  }));
};
export default SegmentedTabs;